import { ERD, ManualAccountCategoryActions } from "@dots-crm/contracts/client";
import { api } from "api";
import { QueryArgsNew } from "api/api.type";
import {
  MANUAL_CATEGORY_ENDPOINTS_URLS,
  MANUAL_CATEGORY_TAGS,
} from "./api-manual-category.constant";

export const {
  useCreateManualCategoryMutation,
  useReadManyManualCategoriesQuery,
  useReadAvailableManualCategoriesQuery,
  useUpdateManualCategoryMutation,
  useDeleteManualCategoryMutation,
} = api.injectEndpoints({
  endpoints: (builder) => ({
    createManualCategory: builder.mutation<
      ERD<ManualAccountCategoryActions["create"]>,
      QueryArgsNew<ManualAccountCategoryActions["create"]>
    >({
      query: ({ payload }) => ({
        url: MANUAL_CATEGORY_ENDPOINTS_URLS.create,
        method: "post",
        payload,
      }),
      invalidatesTags: [MANUAL_CATEGORY_TAGS.manualCategory],
    }),
    readManyManualCategories: builder.query<
      ERD<ManualAccountCategoryActions["readMany"]>,
      QueryArgsNew<ManualAccountCategoryActions["readMany"]>
    >({
      query: ({ query }) => ({
        url: MANUAL_CATEGORY_ENDPOINTS_URLS.readMany,
        method: "get",
        query,
      }),
      providesTags: [MANUAL_CATEGORY_TAGS.manualCategory],
    }),
    readAvailableManualCategories: builder.query<
      ERD<ManualAccountCategoryActions["readAvailable"]>,
      QueryArgsNew<ManualAccountCategoryActions["readAvailable"]>
    >({
      query: ({ query }) => ({
        url: MANUAL_CATEGORY_ENDPOINTS_URLS.readAvailable,
        method: "get",
        query,
      }),
      providesTags: [MANUAL_CATEGORY_TAGS.manualCategory],
    }),
    updateManualCategory: builder.mutation<
      void,
      QueryArgsNew<ManualAccountCategoryActions["update"]>
    >({
      query: ({ payload, params }) => ({
        url: MANUAL_CATEGORY_ENDPOINTS_URLS.update(params),
        method: "put",
        payload,
      }),
      invalidatesTags: [MANUAL_CATEGORY_TAGS.manualCategory],
    }),
    deleteManualCategory: builder.mutation<
      void,
      QueryArgsNew<ManualAccountCategoryActions["delete"]>
    >({
      query: ({ params }) => ({
        url: MANUAL_CATEGORY_ENDPOINTS_URLS.delete(params),
        method: "delete",
      }),
      invalidatesTags: [MANUAL_CATEGORY_TAGS.manualCategory],
    }),
  }),
});
